<template>
    <v-dialog :fullscreen="isMobile" v-model="dialog" max-width="500px" transition="dialog-bottom-transition" @click:outside="hide">
        <v-card v-if="video" tile flat>
            <!-- TITLE -->
            <v-app-bar flat color="white" class="kimsa-elevation">
                <v-row align="center" no-gutters>
                    <v-col cols="2">
                        <v-btn color="secondary" icon @click="hide">
                            <v-icon>$left_arrow</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="8" class="app-title text-truncate">
                        {{ $t('exercises.watch_video') }}
                    </v-col>
                    <v-col cols="2"/>
                </v-row>
            </v-app-bar>

            <v-container>
                <v-row>
                    <v-col align="center" cols="12">
                        <video-player
                            ref="videoPlayer"
                            :options="playerOptions"
                        />
                    </v-col>
                </v-row>
            </v-container>

        </v-card>
    </v-dialog>
</template>

<script>

import {mapMutations, mapState} from "vuex";
import VideoPlayer from '@/components/common/VideoPlayer'

export default {
    props: {
        video: {
            type: String,
            default: null,
        },
        thumb: {
            type: String,
            default: require(`@/assets/img/logo.png`)
        },
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        VideoPlayer,
    },
    data() {
        return {
            dialog: false,
            playerOptions: {
                fluid: true,
                language: 'es',
                controls: true,
                autoplay: false,
                poster: null,
                sources: [{
                    type: 'application/x-mpegURL',
                    src: null,
                    // withCredentials: true,
                }]
            },
        }
    },
    computed: {
        ...mapState(['dialogActive','secondDialogActive']),
    },
    async mounted() {
        const vm = this
    },
    methods: {
        ...mapMutations(['setDialogActive','setSecondDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.loadOptions()
            vm.isSecondDialog ? vm.setSecondDialogActive(true) : vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.isSecondDialog ? vm.setSecondDialogActive(false) : vm.setDialogActive(false)
            vm.$emit('hide')
        },
        loadOptions() {
            const vm = this
            vm.playerOptions.poster = vm.thumb
            vm.playerOptions.sources[0].src = vm.video
            if(vm.$refs.videoPlayer && vm.$refs.videoPlayer.player) {
                vm.$refs.videoPlayer.player.pause();
                vm.$refs.videoPlayer.player.poster(vm.thumb)
                vm.$refs.videoPlayer.player.src({
                    type: 'application/x-mpegURL',
                    src: vm.video,
                })
            }
        },
    },
    watch: {
        dialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
        secondDialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
        thumb(val) {
            if(val) this.loadOptions()
        },
        video(val) {
            if(val) this.loadOptions()
        },
    }
}

</script>

<style scoped>

.app-title {
    font-size: 17px;
    text-align: center;
    font-weight: 700;
}

</style>